<template>
  <gallery :selector="`gallery-${node.nid}`" :articleTitle="node.title" :theme="theme">
    <div slot="thumbnail" v-for="(val, key) in slideshow"
         :enLarge="val.style_1320w"
         :thumbnail="val.style_600x600"
         :progressive="val.style_134w"
         class="thumbnail"
         :key="key"
         :data-w="val.width"
         :data-h="val.height"
         :data-caption="val.title"
         :data-title="val.title"
         :class="{first: key === 0}"
    >
      <div class="photos">
        <progressive-image mode="background" :progressiveImage="progressiveImages[key]" :alt="node.title" />
      </div>
      <div class="gallery-icon" :class="{'number-one': key === 0, 'number-two': key === 1}" v-if="key === 0 || key === 1">
        <svg-icon-gallery width="10%" height="10%"></svg-icon-gallery>
      </div>
      <div class="overlay" v-if="slideshow.length > 4 && key === 3">
        <span>+{{(slideshow.length - key - 1)}}</span>
      </div>
    </div>
  </gallery>
</template>

<script>
  import isEmpty from 'lodash/isEmpty'
  import forEach from 'lodash/forEach'
  import concat from 'lodash/concat'
  import map from 'lodash/map'

  import Gallery from 'components/gallery/Gallery.vue'
  import ProgressiveImage from 'components/widgets/ProgressiveImage.vue'
  import LazyloadImage from 'components/mixins/lazyloadImage'
  import SvgIconGallery from 'static/svg/icon_gallery.svg'

  export default {
    name: 'article-gallery',
    props: {
      nid: [Number, String],
      theme: {
        type: String,
        default: '',
      },
    },
    mixins: [LazyloadImage],
    data() {
      return {
        slideshow: [],
      }
    },
    components: {
      Gallery,
      SvgIconGallery,
      ProgressiveImage,
    },
    created() {
      if (!isEmpty(this.node.images)) {
        forEach(this.node.images, (v) => {
          if (v.slideshow) {
            this.slideshow = concat(this.slideshow, v)
          }
        })
      }
    },
    computed: {
      node() {
        return this.$store.getters.node(this.nid)
      },
      progressiveImages() {
        return map(this.slideshow, item => ({
          src: item.style_600x600,
          loading: item.style_140x140,
          holder: '/image/placeholder/1/1/transparent',
          error: '/image/placeholder/1/1/transparent',
        }))
      },
    },
  }
</script>

<style lang="scss" scoped>
  .placeholder {
    width: 100%;
    height: auto;

  }
</style>



// WEBPACK FOOTER //
// ArticleGallery.vue?f191b738